import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@xpeng/xdragon-ass-components/es/services/ajax';

export interface ListDiagramByCodeReq {
  /**
   * 手册编码
   */
  bookmapCode: string;
  /**
   * 手册版本
   */
  bookmapVersion: string;
  /**
   * 电路编号
   */
  pcode: string;
  /**
   * 文章编号
   */
  topicCode: string;
  /**
   * 文章版本
   */
  topicVersion: string;
}

export type ListDiagramByCodeUsingPostApiResponse = DiagramGroupResp[];

export interface DiagramGroupResp {
  /**
   * 电路图list
   */
  diagrams?: Diagram[];
  /**
   * 电路编码
   */
  pcode?: string;
  /**
   * 电路图类型
   */
  type?: string;
}
export interface Diagram {
  /**
   * 电路图名称
   */
  name?: string;
  /**
   * 电路图文章编码
   */
  topicCode?: string;
  /**
   * 电路图文章版本
   */
  topicVersion?: string;
}

/**
 * @operationId listDiagramByCodeUsingPOST
 * @tags 手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/%E6%89%8B%E5%86%8C/listDiagramByCodeUsingPOST
 */
export function listDiagramByCodeUsingPost(
  data: ListDiagramByCodeReq
): XDragonApiResponsePromise<ListDiagramByCodeUsingPostApiResponse> {
  return ajax({
    url: '/api/tis/web/bookmap/listDiagramByCode',
    method: 'post',
    data: data
  });
}
